import { Paths, ProjectPathParams } from '../../../app/router/app.router';
import { PermissionBoundary } from '../../../core/permissions/permission-boundary.component';
import { WindowTitle } from '../../../core/window-title/window-title.component';
import { ErrorFullPage } from '../../../ui/components/pure/errors/error-full-page/error-full-page.component';
import { ListPageHeader } from '../../../ui/components/pure/page-headers/list/list-page-header.component';
import { Container } from '@mui/material';
import { KioskList } from './components/kiosk-list.component';

export function KioskStatusReportPage({ params }: { params: ProjectPathParams<Paths.kioskConnectionStatusReport> }) {
  return (
    <Container>
      <PermissionBoundary
        availableUiFeatures={['internal-groundfloor']}
        notify={{
          render() {
            return <ErrorFullPage preset="ACCESS_DENIED" />;
          }
        }}
      >
        <WindowTitle pageTitle="Reports" detail="Kiosk Status" />
        <ListPageHeader title="Kiosk Connection Status" subtitle="Monitor kiosk connectivity and connection history" />
        <KioskList projectID={params.projectID} />
      </PermissionBoundary>
    </Container>
  );
}
